module.exports = {"420107001":"红卫路街道","420107002":"冶金街道","420107003":"新沟桥街道","420107004":"红钢城街道","420107005":"工人村街道","420107006":"青山镇街道","420107007":"厂前街道","420107008":"武东街道","420107009":"白玉山街道","420107010":"钢花村街道","420107400":"武钢集团","420107401":"中国一冶有限责任公司","420107402":"武汉钢铁有限公司","420107403":"中国一冶集体企业管理处","420107404":"开发区","420107405":"钢都花园管理委员会","420107406":"北湖工业园管理办公室"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420107.json
// module id = 1703
// module chunks = 0